import postShow from './posts/show';

export const configureRoutes = () => {
  const routes = new Map();
  routes.set('posts-show', postShow);

  return routes;
};
